module.exports = __webpack_public_path__ + "img/DSC_2666-xl.88cff26d.png";